export default [
  {
    name: 'APP_LOGIN_SUCCESS',
    callback: function (representante) {
      this.$toaster.success('Login realizado.');
      this.$store.dispatch('setUser', representante);
      this.$router.push('/pedidos');
    }
  },
  {
    name: 'APP_LOGOUT',
    callback: function (e) {
      // console.log('LOGOUT');
      this.$toaster.success('Logout realizado.');
      this.$router.push({ path: '/login' });
      this.$store.dispatch('setUser', null);
      this.$store.dispatch('setToken', null);
      this.$store.dispatch('setFiltroPedidos', null);
    }
  },
  {
    name: 'APP_AUTH_FAILED',
    callback: function (e) {
      this.$toaster.error('Login ou senha inválidos.');
      this.$store.dispatch('setUser', null);
      this.$store.dispatch('setToken', null);
    }
  },
  {
    name: 'APP_ACCESS_DENIED',
    // @error api response data
    callback: function (msg) {
      this.$router.push({ path: '/login' });
      this.$toaster.error('Sessão expirada. Faça o login novamente.');
      this.$store.dispatch('setUser', null);
      this.$store.dispatch('setToken', null);
    }
  },
  {
    name: 'APP_BAD_REQUEST',
    // @error api response data
    callback: function (msg) {
      this.$toaster.add('Ocorreu um erro de conexão. Entre em contato com a fábrica!', { theme: 'error', timeout: 10000 });
    }
  },
  {
    name: 'APP_CUSTOM_ERROR',
    // @error api response data
    callback: function (msg) {
      this.$toaster.add(msg, { theme: 'error', timeout: 10000 });
    }
  },
  {
    name: 'APP_NOT_FOUND',
    callback: function (msg) {
      this.$router.push('/pedidos');
    }
  },
  {
    name: 'APP_UPDATE_TOKEN',
    callback: function (token) {
      this.$store.dispatch('setToken', token);
    }
  },
  {
    name: 'APP_LOADING',
    callback: function (loading) {
      this.$root.$emit('APP_SET_LOADER', loading);
    }
  }
];



// WEBPACK FOOTER //
// ./src/events.js